export const ADMIN_CREATOR_GET_TABLE = "ADMIN_CREATOR_GET_TABLE";
export const ADMIN_CREATOR_GET_DEFINITION = "ADMIN_CREATOR_GET_DEFINITION";
export const ADMIN_CREATOR_SET_INTERRACTIONS = "ADMIN_CREATOR_SET_INTERRACTIONS";
export const ADMIN_CREATOR_SET_BLOCKS = "ADMIN_CREATOR_SET_BLOCKS";
export const ADMIN_CREATOR_SET_ASSOCIATIONS = "ADMIN_CREATOR_SET_ASSOCIATIONS";
export const SAVE_CREATOR_PICKLIST_RESULT = "SAVE_CREATOR_PICKLIST_RESULT";
export const CREATOR_SAVE_SUCESS = "CREATOR_SAVE_SUCESS";
export const CREATOR_SAVE_ERROR = "CREATOR_SAVE_ERROR";
export const CREATOR_SAVE_CLEAR = "CREATOR_SAVE_CLEAR";
